import i18next, { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { isNullUndefined } from '../../../../../../common/Helpers';

class ELEMENT_CONTRACT_EDP_DISTRIBUCION extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        series: !this.props.inputParam_UseFake ? this.props.inputParam_ComponentContent !== null ? [
            this.props.inputParam_ComponentContent.item.por_monto_acum,
            this.props.inputParam_ComponentContent.item.por_gasto,
            this.props.inputParam_ComponentContent.item.por_saldo] : [] : [33, 33, 33],
        options: {
            chart: {
                type: 'donut',
            },
            plotOptions: {
                pie: {
                    startAngle: -90,
                    endAngle: 90,
                    offsetY: 10
                }
            },
            labels: [t('data-lang-lbl-montoacum'), t('data-lang-lbl-montoep'), t('data-lang-lbl-saldo')],
            grid: {
                padding: {
                    bottom: -100
                }
            },
            legend: {
                position: 'bottom',
                showForSingleSeries: true,
            }
        },
        cardItem: [
            {
                text: t('data-lang-lbl-totalepmonth'),
                value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item !== null ?
                    this.props.inputParam_ComponentContent.item.total_edp_mes : '--') : '--'
            },
            {
                text: t('data-lang-lbl-saldoepmes'),
                value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item !== null ?
                    this.props.inputParam_ComponentContent.item.total_edp_saldo_mes : '--') : '--'
            }
        ]
    };
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_UseFake: false,
  };

  renderContent() {
    return  <>
                <Row className='px-3 h-10' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
                        {
                            this.state.cardItem.map((item, index) => (
                                <Col key={index} className='p-0 m-auto'>
                                    <Card>
                                        <Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                                                {item.text}
                                        </Card.Body>
                                        <div className='m-0 p-0'>
                                            <div className='text-center font-weight-bold'>{!isNullUndefined(item.value) && !isNaN(item.value) ? parseFloat(parseFloat(item.value).toFixed(2)).toLocaleString() : '--'}</div>
                                        </div>
                                    </Card>
                                </Col>
                            ))
                        }
                </Row>
                <Row className='h-85 px-3 pt-3'>
                    <Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                        {t('data-lang-boxname-epdistribution')}
                    </Card.Body>
                    <Col className='p-0 m-auto h-100 border rounded pt-5'>
                        <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height="100%" width="100%" /> :
                    </Col>
                </Row>
            </>
  }

  render() {
    return (
      <>
        {this.renderContent()}
      </>
    );
  }
}

export default ELEMENT_CONTRACT_EDP_DISTRIBUCION;